import { Component, OnInit } from '@angular/core';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogModule,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { UserService } from '../../../../../../../../shared/services/user.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { constants } from '../../../../../../../../shared/constants/constants';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastService } from '../../../../../../../../shared/services/toast.service';

@Component({
    selector: 'multi-select-modal',
    providers: [DialogService],
    standalone: true,
    imports: [
        FloatLabelModule,
        DialogModule,
        ButtonModule,
        FormsModule,
        CommonModule,
        DynamicDialogModule,
        InputNumberModule,
        MultiSelectModule
    ],
    templateUrl: './multi-select-modal.component.html',
    styleUrl: './multi-select-modal.component.scss'
})
export class MultiSelectSelectorModalComponent implements OnInit {

    sessionUser: any = null;
    value: any;
    key: string = '';
    items: any = [];
    selectedTypes: Array<string> = [];

    constructor(
        public ref: DynamicDialogRef,
        private toastService: ToastService,
        public config: DynamicDialogConfig,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.sessionUser = this.userService.getSessionUser();
        this.selectedTypes = this.config?.data?.selectedType && Array.isArray(this.config?.data?.selectedType) && this.config?.data?.selectedType.length ? this.config?.data?.selectedType : [];
        if(this.config?.data?.key == constants.offerSenderFiltersKeys.RANKING){
            this.getRankings();
        }
        else if(this.config?.data?.key == constants.offerSenderFiltersKeys.LOCATION){
            this.getStates();
        }
    }

    getStates(){
        let states = Object.values(constants.states);
        states.forEach((val) => {
          this.items.push({id: val.name, name: val.name})
        });
        if(this.selectedTypes.length && this.selectedTypes.every((type: string) => states.some((state: any) => state.name === type))){
            this.value = this.selectedTypes.map((type: string) => {
                let state = states.find((state: any) => state.name === type);
                if (state) {
                    return {id: state.name, name: state.name};
                } else {
                    return {id: type, name: type};
                }
            });
        }
    }

    getRankings(){
        let rankings = Object.values(constants.userRankings);
        rankings.forEach((val) => {
          this.items.push({id: val.toUpperCase(), name: val})
        });
        if(this.selectedTypes.length && this.selectedTypes.every((type: string) => rankings.includes(type))){
            this.value = this.selectedTypes.map((type: string) => {
                return {id: type, name: type}
            });
        }
    }

    closeDialog() {
        if(this.value?.length){
            this.value = this.value.map((res: any) => {return res.id});
            this.ref.close({type: this.value});
        }
        else{
            this.toastService.showError(`${this.config?.data?.key} can't be empty`);
        }
    }
}
